export default "__VITE_ASSET__21cd0984__"